/**
 * StatGrid — a responsive grid of StatCards (home stats grid, About inline
 * stats, /claims dashboard). Tokens + Tailwind only.
 */
import { StatCard } from './StatCard';
import type { StatCardProps } from './StatCard';
import { cn } from '../../utils';

export interface StatGridProps {
  readonly stats: readonly StatCardProps[];
  readonly columns?: 2 | 3 | 4;
}

export function StatGrid({ stats, columns = 3 }: StatGridProps) {
  const cols = { 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3', 4: 'grid-cols-2 lg:grid-cols-4' }[columns];
  return (
    <div className={cn('grid grid-cols-1 gap-(--space-grid)', cols)}>
      {stats.map((s, i) => (
        <StatCard key={i} {...s} />
      ))}
    </div>
  );
}
